import { Autocomplete } from "@mui/material";
import { styled } from "@mui/material/styles";

// Same component as dm-commerce-b2b-web (CustomAutocomplete): searchable select
// used for relation fields (agent, bank account, party ...). Render the input
// with <CustomInput {...params} placeholder="Search ..." /> via renderInput.
export const CustomAutocomplete = styled(Autocomplete)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    minHeight: "45px",
    // MUI pads the root by 9px: drop it so a single-line field is exactly as tall as CustomInput
    paddingTop: 0,
    paddingBottom: 0,
    alignItems: "center",
    borderRadius: "4px",
    color: "var(--color-text)",
    backgroundColor: "var(--color-bg-white)",
    fontSize: "14px",
    fontFamily: "inherit",
    transition: "background-color 0.3s ease, border-color 0.3s ease",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-primary)",
    },
    "&.Mui-focused": {
      backgroundColor: "var(--color-bg-white)",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--color-primary)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-input-border)",
    },
  },
  "& .MuiInputBase-input": {
    fontWeight: 500,
    "&::placeholder": {
      color: "var(--color-text-muted)",
      opacity: 1,
    },
  },
}));
